// extracted by mini-css-extract-plugin
export default {"stepsContainer":"FormStepsHeader_stepsContainer__7jTYo"};